import React from 'react'
import AccountLoginPage from '../../components/Fundraiser/FundraiserOnboarding/AccountLogin';

const AccountLogin = () => {
  return (
    <AccountLoginPage />
  )
}

export default AccountLogin;